import notify from "utils/notifications";

export const sbdToNeapTokenExchange = async (token, history) => {
  try {
    const baseUrl = process.env.REACT_APP_SERVER_URL;
    const sandboxPath =
      process.env.REACT_APP_ENVIRONMENT === "sandbox" ? "/sandbox" : "";
    const url = `${baseUrl}${sandboxPath}/internal/auth/rest/v1/oauth/clients/${process.env.REACT_APP_CLIENT_ID}/token`;

    const response = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    if (!response.ok) {
      const errorData = await response.json().catch(() => null);
      throw new Error(
        errorData?.message || `Request failed: ${response.statusText}`
      );
    }
    const data = await response.json();
    const accessToken = data?.data?.tokens?.access?.token;

    if (accessToken) {
      localStorage.setItem("token", accessToken);
      history.replace(`/`);
    } else {
      notify("error", data?.message || "Something went wrong");
    }
  } catch (error) {
    notify("error", error?.message || "Something went wrong");
  }
};
